module.exports = __webpack_public_path__ + "img/drink_tea.7d75c3f5.png";